"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryImageFromJSON = GalleryImageFromJSON;
exports.GalleryImageFromJSONTyped = GalleryImageFromJSONTyped;
exports.GalleryImageToJSON = GalleryImageToJSON;
exports.GalleryImageToJSONTyped = GalleryImageToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function GalleryImageFromJSON(json) {
    return GalleryImageFromJSONTyped(json, false);
}
function GalleryImageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'caption': !(0, runtime_1.exists)(json, 'caption') ? undefined : json['caption'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : json['source'],
        'sequenceNr': !(0, runtime_1.exists)(json, 'sequenceNr') ? undefined : json['sequenceNr'],
        'imageUrls': !(0, runtime_1.exists)(json, 'imageUrls') ? undefined : (0, _1.ImageUrlsFromJSON)(json['imageUrls']),
        'type': json['type'],
        'embedHtml': !(0, runtime_1.exists)(json, 'embedHtml') ? undefined : json['embedHtml'],
    };
}
function GalleryImageToJSON(value) {
    return GalleryImageToJSONTyped(value, false);
}
function GalleryImageToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'caption': value.caption,
        'source': value.source,
        'sequenceNr': value.sequenceNr,
        'imageUrls': (0, _1.ImageUrlsToJSON)(value.imageUrls),
        'type': value.type,
        'embedHtml': value.embedHtml,
    };
}
